import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';

export const ToggleWrapper = styled('div')`
  height: ${pxToRem(20)};
  width: ${pxToRem(20)};
`;
